import React, { useState } from 'react'
import Page from 'src/components/Page'
import {
  makeStyles,
  Grid,
  Typography,
  Button,
  Dialog,
  IconButton,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core'
import {
  Link,
  useParams,
} from 'react-router-dom'
import DeleteIcon from 'src/icons/DeleteIcon'
import EditIcon from 'src/icons/EditIcon'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment-jalaali'
import MUIDataTable from 'mui-datatables'
import { ThemeProvider } from '@material-ui/core/styles'
import { getMuiTheme } from '../../utils/TableStyle'
import muiDefaultOptions from '../../constants/muiTableOptions'
import { selectUserInfo } from '../../app/slices/userSlice'
import { getAllPackages, selectorAllPackage } from '../../app/slices/packageSlice'

const PACKAGE_NAME = {
  ONE: 'رده سنی تا 9 سال',
  TWO: 'رده سنی 10 تا 12 سال',
  THREE: 'رده سنی 13 تا 15 سال',
  FOUR: 'رده سنی 16 تا 18 سال',
}

const PACKAGE_AGE = {
  ONE: '9 - 0',
  TWO: '12 - 10',
  THREE: '15 - 13',
  FOUR: '18 - 16',
}

const useStyle = makeStyles((theme) => ({
  root: {
  },
  title: {
    marginBottom: 15,
    backgroundColor: '#c2c2c2',
    padding: '10px 0',
    borderRadius: '20px',
    margin: '0 auto',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: '600',
  },
  icon: {
    marginRight: 10,
  },
  valueCell: {
    color: '#000',
    [theme.breakpoints.down('sm')]: {
      textAlign: 'right',
    },
  },
  icons: {
    color: '#b2b6c0',
    transition: '0.2s',
    '&:hover': {
      color: '#f39994',
    },
  },

}))

export const Package = () => {
  const classes = useStyle()
  const { packageId } = useParams()
  const dispatch = useDispatch()
  const { role } = useSelector(selectUserInfo)
  // const allPackage = useSelector(selectorUserPackage)
  const allPackage = useSelector(selectorAllPackage)

  const getPackage = allPackage?.find((item) => item.id === 6)

  let name
  let age

  // if (+packageId === 2) {
  //   name = PACKAGE_NAME.ONE
  //   age = PACKAGE_AGE.ONE
  // } else if (+packageId === 4) {
  //   name = PACKAGE_NAME.TWO
  //   age = PACKAGE_AGE.TWO
  // } else if (+packageId === 5) {
  //   name = PACKAGE_NAME.THREE
  //   age = PACKAGE_AGE.THREE
  // } else if (+packageId === 6) {
  //   name = PACKAGE_NAME.FOUR
  //   age = PACKAGE_AGE.FOUR
  // }

  if (+packageId === 1) {
    name = PACKAGE_NAME.ONE
    age = PACKAGE_AGE.ONE
  } else if (+packageId === 2) {
    name = PACKAGE_NAME.TWO
    age = PACKAGE_AGE.TWO
  } else if (+packageId === 3) {
    name = PACKAGE_NAME.THREE
    age = PACKAGE_AGE.THREE
  } else if (+packageId === 4) {
    name = PACKAGE_NAME.FOUR
    age = PACKAGE_AGE.FOUR
  }
  const [packageIdToDelete, sePackageIdToDelete] = useState(null)

  React.useEffect(() => {
    if ([2, 3].includes(role?.roleId)) {
      dispatch(getAllPackages())
    }
  }, [])

  const COLUMNS = [
    {
      name: 'id',
      label: 'ردیف',
      options: {
        customBodyRender: (value) => (
          <p className={classes.valueCell}>
            {value}
          </p>
        ),
      },
    },
    {
      name: 'id',
      label: 'نام آزمون',
      options: {
        customBodyRender: (value) => {
          const exam = getPackage?.exams?.find((item) => item?.id === value)
          let link = `./${value}`

          if (exam?.type === 2) {
            link = `../exam/${value}`
          }

          return (
            <p className={classes.valueCell}>
              <Link to={link}>
                <p
                  style={{
                    color: '#000',
                    whiteSpace: 'nowrap',
                    //  marginRight: '-100px',
                    float: window.outerWidth < 960 ? 'left' : '',
                  }}
                >
                  {exam?.name}

                </p>
              </Link>
            </p>
          )
        },
      },
    },
    {
      name: 'createDate',
      label: 'تاریخ ایجاد',
      options: {
        customBodyRender: (value) => (
          <p className={classes.valueCell}>{value ? moment(value)?.format('jYYYY/jMM/jDD') : '--'}</p>
        ),
      },
    },
    {
      name: 'mustOptionSelectCount',
      label: 'رده سنی',
      options: {
        customBodyRender: () => (
          <p className={classes.valueCell}>{age}</p>
        ),
      },
    },
    {
      name: 'id',
      label: ' ',
      options: {
        sort: false,
        filter: false,
        customBodyRender: (value, { rowData }) => {
          return (
            <div>
              <Link to={`./edit/${value}`}>

                <IconButton>
                  <EditIcon className={classes.icons} />
                </IconButton>

              </Link>
              <IconButton onClick={() => {
                sePackageIdToDelete(rowData[0])
              }}
              >
                <DeleteIcon
                  className={classes.icons}
                />

              </IconButton>
            </div>
          )
        },
      },
    },
  ]

  const handleClose = () => {
    sePackageIdToDelete(null)
  }

  return (
    <Page
      className={classes.root}
      title="فهرست آزمون‌ها"
    >
      <Grid className={classes.root}>
        <Grid container justify="space-between" className={classes.title}>

          <Typography variant="h4" component="h4">
            {name}
          </Typography>
        </Grid>

        <ThemeProvider theme={getMuiTheme}>
          <MUIDataTable
            data={getPackage?.exams}
            columns={COLUMNS}
            options={{
              ...muiDefaultOptions,
              serverSide: true,
              filter: false,
              print: false,
              download: false,
              search: false,
              rowHover: true,
              selectableRows: 'none',
              searchable: true,
              sort: true,
              pagination: true,
              viewColumns: false,
            }}
          />
        </ThemeProvider>
      </Grid>
      <Dialog
        className={classes.deleteDialog}
        open={packageIdToDelete}
        onClose={() => handleClose(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle className={classes.dialogHeader} id="alert-dialog-title">حذف کاربر</DialogTitle>
        <DialogContent>
          <DialogContentText className={classes.dialogDesc} id="alert-dialog-description">
            آیا از حذف این کاربر اطمینان دارید؟
          </DialogContentText>
        </DialogContent>
        <DialogActions className={classes.dialogButtons}>
          <Button onClick={() => handleClose(false)} className={classes.cancelModalBtn}>
            لغو
          </Button>
          <Button onClick={() => handleClose(true)} className={classes.deleteModalBtn} autoFocus>
            حذف
          </Button>
        </DialogActions>
      </Dialog>

    </Page>

  )
}

export default Package
